import { LineChart, PieChart, BarChart, ScatterChart } from '#client/components/Charts';

import AvailabilityList from './components/AvailabilityList';
import BulletList from './components/BulletList';
import HighlightSection from './components/HighlightSection';
import MarkdownContent from './components/MarkdownContent';
import SimilarBusinesses from './components/SimilarBusinesses';
import StatCardSection from './components/StatCardSection';
import TableSection from './components/TableSection';
import TrademarkSearch from './components/TrademarkSearch';

/**
 * Component registry for report section content types.
 * Each entry maps a component type string to a render function.
 * The render function receives the content and optional context, returning a React element.
 *
 * To add a new component type:
 * 1. Import the component
 * 2. Add an entry to this registry with the component type as key
 * 3. The VALID_COMPONENT_TYPES array will automatically include the new type
 */
export const COMPONENT_REGISTRY = {
  // Text content components
  markdown: (content, { isBubble }) => (
    <MarkdownContent content={content} viewType={isBubble ? 'report' : 'default'} />
  ),

  // Business Names specific components
  'availability-list': (content) => <AvailabilityList items={content} />,
  'trademark-search': (content) => <TrademarkSearch data={content} />,
  'similar-businesses': (content) => <SimilarBusinesses items={content} />,

  // Chart components - Market Report
  'chart-line': (content) => <LineChart data={content.data} {...(content.config || {})} />,
  'chart-pie': (content) => <PieChart data={content.data} {...(content.config || {})} />,
  'chart-bar': (content) => <BarChart data={content.data} {...(content.config || {})} />,
  'chart-scatter': (content) => <ScatterChart data={content.data} {...(content.config || {})} />,

  // Other Market Report components
  table: (content) => <TableSection content={content} />,
  highlight: (content) => <HighlightSection content={content} />,
  'stat-cards': (content) => <StatCardSection content={content} />,

  // Subsection components (reusable)
  'bullet-list': (content) => <BulletList content={content} />
};

/**
 * Valid component types extracted from registry for PropTypes validation
 */
export const VALID_COMPONENT_TYPES = Object.keys(COMPONENT_REGISTRY);

/**
 * Threshold for determining when to use smaller font size for cost ranges
 * If cost range text is longer than this or on mobile, use 'sm' size
 */
export const COST_RANGE_LENGTH_THRESHOLD = 45;

/**
 * Report types supported by ReportPanel components
 */
export const REPORT_TYPES = ['idea', 'name', 'cost', 'market'];

export const BUBBLE_TITLE = 'Why This works for you';
